export const EMPLOYEE_ROLE_CODES = {
  ADMIN: 1,
  STAFF: 2,
  KITCHEN: 3,
};

const extractOutletTypeValue = (value) => {
  if (value && typeof value === 'object') {
    return String(value.String ?? value.string ?? value.value ?? '').trim();
  }

  return String(value || '').trim();
};

export const normalizeEmployeeOutletType = (value) => {
  const normalized = extractOutletTypeValue(value)
    .toLowerCase()
    .replace(/[+\s/-]+/g, '_');

  switch (normalized) {
    case 'restaurant':
    case 'resto':
    case 'cafe':
    case 'coffee_shop':
      return 'restaurant';
    case 'gym_store':
    case 'gym_and_store':
    case 'store_gym':
    case 'store_and_gym':
      return 'gym_store';
    case 'hybrid':
    case 'gym_pos':
    case 'gym_and_pos':
    case 'gym_restaurant':
      return 'hybrid';
    case 'cafe_gym':
    case 'cafe_and_gym':
    case 'gym_cafe':
    case 'gym_and_cafe':
      return 'cafe_gym';
    case 'cafe_store':
    case 'cafe_and_store':
    case 'store_cafe':
    case 'store_and_cafe':
      return 'cafe_store';
    case 'building_material_store':
    case 'store_bahan_bangunan':
    case 'toko_bahan_bangunan':
    case 'bahan_bangunan_store':
    case 'hardware_store':
    case 'material_store':
    case 'toko_bangunan':
    case 'toko_material':
      return 'building_material_store';
    default:
      return normalized;
  }
};

export const outletSupportsKitchenRole = (value) => {
  const normalizedOutletType = normalizeEmployeeOutletType(value);
  return ['restaurant', 'hybrid', 'cafe_gym', 'cafe_store'].includes(normalizedOutletType);
};

export const getEmployeeRoleOptions = (outletType) => {
  const options = [
    { value: EMPLOYEE_ROLE_CODES.ADMIN, label: 'Admin' },
    { value: EMPLOYEE_ROLE_CODES.STAFF, label: 'Staff' },
  ];

  if (outletSupportsKitchenRole(outletType)) {
    options.push({ value: EMPLOYEE_ROLE_CODES.KITCHEN, label: 'Kitchen' });
  }

  return options;
};

export const getEmployeeRoleLabel = (roleCode) => {
  switch (Number(roleCode)) {
    case EMPLOYEE_ROLE_CODES.ADMIN:
      return 'Admin';
    case EMPLOYEE_ROLE_CODES.KITCHEN:
      return 'Kitchen';
    case EMPLOYEE_ROLE_CODES.STAFF:
    default:
      return 'Staff';
  }
};
